import dayjs from 'dayjs';

interface isValidDateOptions {
  date: dayjs.Dayjs;
  minDate?: dayjs.Dayjs | null;
  maxDate?: dayjs.Dayjs | null;
}

export function isValidDate({
  date,
  minDate,
  maxDate,
}: isValidDateOptions): boolean {
  if (minDate && maxDate) {
    return (
      date.valueOf() >= minDate.valueOf() && date.valueOf() <= maxDate.valueOf()
    );
  }

  if (minDate) {
    return date.valueOf() >= minDate.valueOf();
  }

  if (maxDate) {
    return date.valueOf() <= maxDate.valueOf();
  }

  return date.isValid();
}
